export const upsellsSortMapping = {
  title: 'title' as const,
  type: 'type' as const,
  enabled: 'enabled' as const,
  createdAt: 'createdAt' as const,
  id: 'id' as const,
};

export const upsellsQueryParamsMapping = {};
